export default __webpack_public_path__ + "static/media/O0001.c2d2514b.png";